// Placeholder 2.0 - Realistic Dragging Effect for GrapesJS
// Version 0.1.3 (28.10.2023)

export default function placeholder2(editor, opts = {}) {
  const options = {
    dragDefault: opts.dragDefault || [],
    dragClasses: opts.dragClasses || ['gjs-selected', 'gjs-freezed', 'animation'],
    animation: opts.animation || 'animation1',
    dragPlace: opts.dragPlace || '',
    customAnimation: opts.customAnimation || '',
  };

  // Default animations
  const animations = {
    animation1: `@keyframes slidein { from { max-height: 0px; transform: scale(0); opacity: 0; } to { max-height: 1000px; transform: scale(1); opacity: 1; } }`,
    animation2: `@keyframes fadein { from { opacity: 0; } to { opacity: 1; } }`,
    animation3: `@keyframes pop { from { transform: scale(0.8); opacity: 0.5; } to { transform: scale(1); opacity: 1; } }`,
    animation4: `@keyframes bounce { 0%{transform:scale(0.8);} 50%{transform:scale(1.05);} 100%{transform:scale(1);} }`,
    animation5: `@keyframes drop { from { transform: translateY(-40px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }`,
    none: '',
  };

  // Inject animation CSS
  function injectAnimationCSS(name) {
    let css = animations[name] || '';
    if (options.customAnimation) css += options.customAnimation;
    if (css) {
      const style = document.createElement('style');
      style.innerHTML = css;
      document.head.appendChild(style);
    }
  }

  // Remove existing placeholder
  function removePlaceholder() {
    const el = document.querySelector('.gjs-drag-placeholder2');
    if (el) el.remove();
  }

  // Create the placeholder element
  function createPlaceholder(component) {
    removePlaceholder();
    let html = '';
    if (options.dragPlace) {
      html = options.dragPlace;
    } else if (component) {
      html = component.view.el.outerHTML;
    } else if (options.dragDefault.length) {
      html = options.dragDefault[0];
    } else {
      html = '<div style="padding:32px;text-align:center;">Dragging...</div>';
    }
    const div = document.createElement('div');
    div.className = 'gjs-drag-placeholder2 ' + options.dragClasses.join(' ');
    div.innerHTML = html;
    div.style.position = 'absolute';
    div.style.pointerEvents = 'none';
    div.style.opacity = '0.85';
    div.style.zIndex = '99999';
    div.style.background = '#fff';
    div.style.border = '2px dashed #2563eb';
    div.style.boxShadow = '0 4px 24px rgba(0,0,0,0.10)';
    div.style.transition = 'all 0.2s cubic-bezier(.4,2,.6,1)';
    div.style.animation = options.animation !== 'none' ? `${options.animation} 0.5s` : '';
    return div;
  }

  // Listen for drag events
  editor.on('component:drag:start', (model) => {
    injectAnimationCSS(options.animation);
    const ph = createPlaceholder(model);
    document.body.appendChild(ph);
    // Position placeholder under mouse
    function move(e) {
      ph.style.left = e.clientX + 10 + 'px';
      ph.style.top = e.clientY + 10 + 'px';
    }
    window.addEventListener('mousemove', move);
    editor.once('component:drag:end', () => {
      removePlaceholder();
      window.removeEventListener('mousemove', move);
    });
  });
} 